<template>
  <HomeBody/>
</template>

<script>
// @ is an alias to /src
import HomeBody from '@/components/HomeBody.vue'

export default {
  name: 'HomeView',
  components: {
    HomeBody
  }
}
</script>
